import { AxiosResponse } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { Contact, ContactType } from "../../../models/Admin/Contact";
import { PageableCollection } from "../../../models/PageableCollection";
import msalRestClient from "../../../services/clients/MsalRestClient";

// #region Type Declaration

/**
 * TBD ...
 */
type ContactState = {
    checked: boolean
    contact: Contact
}

/**
 * TBD ...
 */
type Event2ContactProps = {
    onSuccess: (contactIds: number[]) => void
}

// #endregion

const Event2Contact = ({ onSuccess }: Event2ContactProps) => {

    // #region Init State

    /**
     * ...
     */
    let initContacts: PageableCollection<ContactState> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    // #endregion

    // #region States & Hooks

    const [show, setShow] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState<string>();
    const [contacts, setContacts]   = useState<PageableCollection<ContactState>>(initContacts);

    useEffect(() => { fetchFromApi() }, [])
    useEffect(() => {

        const timer = setTimeout(() =>
        {
            if (searchTerm !== undefined)
            {
                msalRestClient.get<PageableCollection<Contact>>("/api/contacts?email=" + searchTerm)
                    .then(response => onApiSuccess(response));
            }

        }, 1000)

        return () => clearTimeout(timer);

    }, [searchTerm])

    // #endregion

    /**
     * TBD ...
     */
    const fetchFromApi = (page?: number) => {

        msalRestClient.get<PageableCollection<Contact>>("/api/contacts?page=" + (page ? page : 1))
            .then(response => onApiSuccess(response))
            .catch(error   => console.error(error));
    }

    /**
     * ...
     * @param contactResponse
     */
    const onApiSuccess = (contactResponse: AxiosResponse<PageableCollection<Contact>, any>) => {
        if (contactResponse.status === 200)      { setContacts(x => ({ totalPages: x?.totalPages ?? 0, count: x?.count ?? 0, next: x?.next ?? "", previous: x?.previous ?? "", results: contactResponse.data.results.map(y => ({ checked: false, contact: y } as ContactState)) }) as PageableCollection<ContactState>); }
        else if (contactResponse.status === 204) { setContacts(initContacts); }
    }

    /**
     * ...
     * @param type
     */
    const renderTypeInformations = (type: ContactType) => {

        switch (type) {
            case ContactType.Assistant: return <span className="badge bg-dark">Assistant</span>
            case ContactType.Lawyer:    return <span className="badge bg-dark">Lawyer</span>
            case ContactType.Employee:  return <span className="badge bg-dark">Employee</span>
        }
    }

    /**
     * ...
     * @param event
     * @param index
     */
    const onCheckedStateChange = (event: ChangeEvent<HTMLInputElement> | undefined, index: number) => {

        let contact = contacts.results.at(index);
        if (contact)
        {
            let updated: ContactState    = { ...contact, checked: !contact.checked }
            let results: ContactState[] = [...contacts.results.slice(0, index), updated, ...contacts.results.slice(index + 1)]

            setContacts({ ...contacts, results: results });
        }
    }

    /**
     * 
     */
    const onSubmit = () => {

        let contactIds: number[] = contacts.results.filter(x => x.checked).map(x => x.contact.id);
        setShow(false);

        onSuccess(contactIds);
    }

    return (
        <>
            <button className="btn btn-success" onClick={e => setShow(true)}>
                <i className="bi bi-plus-lg" /> 
            </button>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-body">

                            <div className="row">
                                <div className="col-12">

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th colSpan={4}>
                                                    <div className="form-group col-12">
                                                        <label className="fw-bold">Search</label>
                                                        <input type="text" className="form-control" onChange={e => setSearchTerm(e.target.value)} placeholder="Search for employee by email" />
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>Name</th>
                                                <th>Type</th>
                                                <th>E-Mail</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contacts.results.map((value, index) => {
                                                    return (
                                                        <tr key={"crow_" + index} className={value.checked ? "checked" : ""}>
                                                            <td>
                                                                <input className="form-check-input" id={"chk_" + index} checked={value.checked} type="checkbox" onChange={e => onCheckedStateChange(e, index)}  />
                                                            </td>
                                                            <td>{value.contact.firstname + " " + value.contact.lastname}</td>
                                                            <td>{renderTypeInformations(value.contact.contactType)}</td>
                                                            <td>{value.contact.email}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-danger" onClick={e => setShow(false)}>
                                <i className="bi bi-x-lg" />
                            </button>
                            <button className="btn btn-success" disabled={!contacts.results.some(x => x.checked)} onClick={onSubmit}>
                                Add <b>{contacts.results.filter(x => x.checked).length}</b> contacts to the event
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default Event2Contact;